import React, { useState, useMemo, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import { FaSearch, FaFileDownload } from "react-icons/fa";
import { HiRefresh } from "react-icons/hi";
import Loader from "../component/Loader";
import "../css/makeTable.css";
import { getData, postData } from "../store/utils";
import Select from "react-select";
import { useDebounce } from 'use-debounce';

const SalesDashboard = () => {
  const inputRef = useRef();
  const [salesUserData, setSalesUserData] = useState();
  const [onboardData, setOnboardData] = useState();
  const [visitData, setVisitData] = useState();
  const [merchantRefrenceType, setMerchantRefrenceType] = useState();
  const [searchBoxValue, setSearchBoxValue] = useState();
  const [isLoadingOn, setIsLoadingOn] = useState(false);
  const [value] = useDebounce(searchBoxValue, 1000);
  const [selectedOption, setSelectedOption] = useState(null);

  const [errorMessage, setErrorMessage] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [orderBy, setOrderBy] = useState("");

  const userRole = localStorage.getItem("USER_ROLE");

  // order pagination
  const [pageCount, setPageCount] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageIndex, setPageIndex] = useState(0); // Page index starts from 0
  const [pageSize, setPageSize] = useState(10);
  const [salesUserTotals, setSalesUserTotals] = useState({
    t: {
      tmerchatntQoutationGeneratedCountTotal: 0,
      tmerchatntQoutationGeneratedAmountTotal: "0",
      tapprovedOrderCoutnTotal: 0,
      tapprovedOrderAmountTotal: "0",
      tmerchatApprovelPendingOrderCountTotal: 0,
      tmerchatApprovelPendingOrderAmountTotal: "0"
    },
    m: {
      mmerchatntQoutationGeneratedCountTotal: 0,
      mmerchatntQoutationGeneratedAmountTotal: "0",
      mapprovedOrderCoutnTotal: 0,
      mapprovedOrderAmountTotal: "0",
      mmerchatApprovelPendingOrderCountTotal: 0,
      mmerchatApprovelPendingOrderAmountTotal: "0"
    }
  });  

  //   onboard page
  const [onboardPageCount, setonboardPageCount] = useState(0);
  const [onboardTotalRecords, setOnboardTotalRecords] = useState(0);
  const [onboardPageIndex, setOnboardPageIndex] = useState(0); // Page index starts from 0
  const [onboardPageSize, setOnboardPageSize] = useState(10);
  const [onboardingTotals, setOnboardingTotals] = useState({
    t: {
      tfullyOnboardedMerchantCountTotal: 0,
      tpartiallyOnboardedMerchantCountTotal: 0,
    },
    m: {
      mfullyOnboardedMerchantCountTotal: 0,
      mpartiallyOnboardedMerchantCountTotal: 0,
    },
  });

  //   onboard page
  const [visitPageCount, setVisitPageCount] = useState(0);
  const [visitTotalRecords, setVisitTotalRecords] = useState(0);
  const [visitPageIndex, setVisitPageIndex] = useState(0); // Page index starts from 0
  const [visitPageSize, setVisitPageSize] = useState(10);
  const [visitTotals, setVisitTotals] = useState({
    t: {
      tFreshVisitsMerchantCountTotal: 0,
      tRevisitMerchantCountTotal: 0,
    },
    m: {
      mFreshVisitsMerchantCountTotal: 0,
      mRevisitMerchantCountTotal: 0,
    },
  });

  const searchByOption = [
    { value: 0, label: "Employee Name" },
    { value: 1, label: "Mobile No." },
    { value: 2, label: "Employee code" },
  ];

  const handleInputChange = (e) => {
    // alert("zmhfgsdhsdf");
    if (merchantRefrenceType === "Mobile No.") {
      const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
      setSearchBoxValue(value);
    } else {
      setSearchBoxValue(e.target.value);
    }
  };

  const searchManualData = async () => {
    const trimmedValue = searchBoxValue?.trim();
    if (!trimmedValue) return;

    if (merchantRefrenceType === null || merchantRefrenceType === undefined || ![0, 1, 2].includes(merchantRefrenceType)) {
      Swal.fire({
        icon: "warning",
        title: "Reference type not selected!",
        text: "Please select a valid merchant reference type before searching.",
      });
      return;
    }  

    let filterData = {};

    if (merchantRefrenceType === 0) {
      filterData = {
        name: trimmedValue,
      };
    } else if (merchantRefrenceType === 1) {
      filterData = {
        mobileNumber: trimmedValue,
      };
    } else if (merchantRefrenceType === 2) {
      filterData = {
        employeeCode: trimmedValue,
      };
    }
    setIsLoadingOn(true);
    const queryParams = new URLSearchParams(filterData).toString();
    const tempData = await getData(
      `dashboard/salesEmployeeDashBoardOrder?${queryParams}`
    );
    const tempOnboard = await getData(
      `dashboard/salesEmployeeDashBoardOnboarding?${queryParams}`
    );
    const tempVisit = await getData(
      `dashboard/salesEmployeeDashBoardVisit?${queryParams}`
    );

    setIsLoadingOn(false);
    if (tempData.statusCode === 200) {
      setSalesUserData(tempData.data);
      setOnboardData(tempOnboard.data);
      setVisitData(tempVisit.data);
      setSalesUserTotals(tempData.totals);
      setOnboardingTotals(tempOnboard.totals);
      setVisitTotals(tempVisit.totals);
    } else {
      Swal.fire({
        title: "Error!",
        text: tempData.data.errors.msg || "Something went wrong",
      });
    }
  };

  useEffect(() => {
    if (value?.trim()) {
      searchManualData();
    }
  }, [value, merchantRefrenceType]);

  const resetFilters = () => {
    inputRef.current.value = "";
    setSelectedOption(null);
    setMerchantRefrenceType("");
    setSearchBoxValue("");
    getSalesData();
    getOnboardingData();
    getVisitData();
  };

  const getSalesData = async (
    page = 0,
    pageSize = 10,
    sortBy = "",
    orderBy = ""
  ) => {
    setIsLoadingOn(true);
    let newApi = `dashboard/salesEmployeeDashBoardOrder?page=${
      page + 1
    }&pageSize=${pageSize}`;
    const tempData = await getData(newApi);
    setIsLoadingOn(false);
    if (tempData.statusCode === 200) {
      setSalesUserData(tempData.data);
      setSalesUserTotals(tempData.totals);
      setPageCount(tempData.pagination.page);
      setTotalRecords(tempData.pagination.total);
      setErrorMessage("");
    }
  };

  useEffect(() => {
    getSalesData(pageIndex, pageSize, sortBy, orderBy);
  }, [pageIndex, pageSize, sortBy, orderBy]);

  const getOnboardingData = async (
    page = 0,
    pageSize = 10,
    sortBy = "",
    orderBy = ""
  ) => {
    setIsLoadingOn(true);

    let newApi = `dashboard/salesEmployeeDashBoardOnboarding?page=${
      page + 1
    }&pageSize=${pageSize}`;
    const tempData = await getData(newApi);

    setIsLoadingOn(false);
    if (tempData.statusCode === 200) {
      setOnboardData(tempData.data);
      setOnboardingTotals(tempData.totals);
      setonboardPageCount(tempData.pagination.page);
      setOnboardTotalRecords(tempData.pagination.total);
      setErrorMessage("");
    }
  };

  useEffect(() => {
    getOnboardingData(onboardPageIndex, onboardPageSize, sortBy, orderBy);
  }, [onboardPageIndex, onboardPageSize, sortBy, orderBy]);

  const getVisitData = async (
    page = 0,
    pageSize = 10,
    sortBy = "",
    orderBy = ""
  ) => {
    setIsLoadingOn(true);

    let newApi = `dashboard/salesEmployeeDashBoardVisit?page=${
      page + 1
    }&pageSize=${pageSize}`;
    const tempData = await getData(newApi);
    setIsLoadingOn(false);
    if (tempData.statusCode === 200) {
      setVisitData(tempData.data);
      setVisitTotals(tempData.totals);
      setVisitPageCount(tempData.pagination.page);
      setVisitTotalRecords(tempData.pagination.total);
      setErrorMessage("");
    }
  };

  useEffect(() => {
    getVisitData(visitPageIndex, visitPageSize, sortBy, orderBy);
  }, [visitPageIndex, visitPageSize, sortBy, orderBy]);

  const totalPages = Math.ceil(totalRecords / pageSize);
  const onboardTotalPages = Math.ceil(onboardTotalRecords / pageSize);
  const visitTotalPages = Math.ceil(visitTotalRecords / pageSize);
  const canNextPage = pageIndex < totalPages - 1;
  const canPreviousPage = pageIndex > 0;

  const canNextPageOnboard = onboardPageIndex < onboardTotalPages - 1;
  const canPreviousPageOnboard = onboardPageIndex > 0;

  const canNextPageVisit = visitPageIndex < visitTotalPages - 1;
  const canPreviousPageVisit = visitPageIndex > 0;

  const handleNextPage = () => {
    setPageIndex(pageIndex + 1);
    if (canNextPage) {
      setPageIndex(pageIndex + 1);
    }
  };
  const handlePreviousPage = () => {
    if (canPreviousPage) {
      setPageIndex(pageIndex - 1);
    }
  };

  const handleOnboardNextPage = () => {
    if (canNextPageOnboard) {
      setOnboardPageIndex(onboardPageIndex + 1);
    }
  };
  const handleOnboardPreviousPage = () => {
    if (canPreviousPageOnboard) {
      setOnboardPageIndex(onboardPageIndex - 1);
    }
  };

  const handleVisitNextPage = () => {
    if (canNextPageVisit) {
      setVisitPageIndex(visitPageIndex + 1);
    }
  };
  const handleVisitPreviousPage = () => {
    if (canPreviousPageVisit) {
      setVisitPageIndex(visitPageIndex - 1);
    }
  };
  const handleSetPageSize = (size) => {
    setPageSize(size);
    setPageIndex(0);
  };
  const handleOnboardSetPageSize = (size) => {
    setOnboardPageSize(size);
    setOnboardPageIndex(0);
  };
  const handleVisitSetPageSize = (size) => {
    setVisitPageSize(size);
    setVisitPageIndex(0);
  };

  const handleGotoPage = (page) => {
    if (page < 0 || page >= totalPages) {
      setErrorMessage(`No data to display`);
    } else {
      setErrorMessage("");

      setPageIndex(page);
    }
  };

  const handleOnboardGotoPage = (page) => {
    if (page < 0 || page >= onboardTotalPages) {
      setErrorMessage(`No data to display`);
    } else {
      setErrorMessage("");
      setOnboardPageIndex(page);
    }
  };

  const handleVisitGotoPage = (page) => {
    if (page < 0 || page >= visitTotalPages) {
      setErrorMessage(`No data to display`);
    } else {
      setErrorMessage("");
      setVisitPageIndex(page);
    }
  };

  return (
    <div>
      {isLoadingOn ? <Loader /> : ""}
      <style>
        {`
                  

                    .dashboardTable th {
                        // position: sticky;
                        top: 0;
                        background-color: #f4f4f4;
                        font-weight: bold;
                        font-family: Roboto, Helvetica, Arial, sans-serif;
                        font-size: 0.875rem;
                        line-height: 2;
                        letter-spacing: 0.01071em;
                        border-bottom: 1px solid rgb(224, 224, 224);
                        color: rgba(0, 0, 0, 0.87);
                        padding: 20px;
                        // height: 100px;
                        text-align: left;
                        white-space: nowrap;
                    }

                    th.main-header {
    background-color: #e8650c; /* Darker orange */
    color: white;
    padding: 10px;
    text-align: center;
}

/* Second Row (Sub-Headers) */
th.sub-header {
    background-color: #fd7e14; /* Theme orange */
    color: white;
    padding: 8px;
}

/* Third Row (Amount, Count Headers) */
th.sub-sub-header {
    background-color: #ffb380; /* Lighter orange */
    color: black;
    padding: 6px;
}

 /* Pagination */
                    .pagination {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-top: 20px;
                    }

                    .pagination button {
                        padding: 5px 10px;
                        margin-right: 5px;
                        cursor: pointer;
                    }

                    .pagination select,
                    .pagination input {
                        padding: 5px;
                        margin-left: 10px;
                    }

                    .selectDisplayNoOfRecords {
                        width: 120px;
                    }

                    .gotoPage {
                        width: 60px;
                    }

                `}
      </style>

      <h3 className="tableHeaderMsg">Employee Sales Table</h3>
      <div className="customHeaderTable">
        <div className="container-fluid">
          <div className="row alignmentTable">
            <div className="col-md-2">
              <Select
                placeholder="Emp.. Ref No."
                name="role"
                // ref={selectRef}
                options={searchByOption}
                value={selectedOption}
                onChange={(e) => {
                  setSelectedOption(e);
                  setMerchantRefrenceType(e.value);
                }}
              />
            </div>
            <div className="col-md-2">
              <input
                className="searchInputField"
                ref={inputRef}
                type={merchantRefrenceType === "Mobile No." ? "number" : "text"}
                onChange={handleInputChange}
                placeholder="Enter Details"
              />
            </div>
            {/* <div className="col-md-2 text-center" onClick={searchManualData}>
              <button className="searchTableData">
                <FaSearch /> Search
              </button>
            </div> */}

            <div className="col-md-2 text-center" onClick={resetFilters}>
              <button className="resetTableData">
                <HiRefresh /> Reset
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* onBoarding */}
      <div>
        <h4 style={{ marginTop: 40 }}>Onboarding</h4>

        <table
          border="1"
          className="dashboardTable"
          cellPadding="10"
          style={{
            width: "100%",
            borderCollapse: "collapse",
            textAlign: "center",
          }}
        >
          <thead style={{ textAlign: "center" }}>
            <tr>
              <th rowSpan="2">Sr. No</th>
              <th rowSpan="2">Name</th>
              <th colSpan="2">Today</th>
              <th colSpan="2">Monthly</th>
            </tr>
            <tr>
              <th colSpan="1" style={{ background: "#ffb380", color: "white" }}>
                Fully
              </th>
              <th colSpan="1" style={{ background: "#ffb380", color: "white" }}>
                Partialy
              </th>
              <th colSpan="1" style={{ background: "#ffb380", color: "white" }}>
                Fully
              </th>
              <th colSpan="1" style={{ background: "#ffb380", color: "white" }}>
                Partialy
              </th>
            </tr>
          </thead>
          <tbody border="1">
            {onboardData &&
              onboardData.map((row, index) => (
                <tr key={index} border="1">
                  <td>
                    <strong>
                      {onboardPageIndex * onboardPageSize + index + 1}
                    </strong>
                  </td>
                  <td>{row.name}</td>
                  <td>{row.tfullyOnboardedMerchantCount}</td>
                  <td>{row.tpartiallyOnboardedMerchantCount}</td>
                  <td>{row.mfullyOnboardedMerchantCount}</td>
                  <td>{row.mpartiallyOnboardedMerchantCount}</td>
                </tr>
              ))}
              
              {/* Grand Total Row */}
              <tr style={{ backgroundColor: "#f4f4f4", fontWeight: "bold" }}>
                <td colSpan="2" style={{ textAlign: "center" }}><strong>Grand Total</strong></td>
                <td><strong>{onboardingTotals.t.tfullyOnboardedMerchantCountTotal}</strong></td>
                <td><strong>{onboardingTotals.t.tpartiallyOnboardedMerchantCountTotal}</strong></td>
                <td><strong>{onboardingTotals.m.mfullyOnboardedMerchantCountTotal}</strong></td>
                <td><strong>{onboardingTotals.m.mpartiallyOnboardedMerchantCountTotal}</strong></td>
              </tr>
          </tbody>
        </table>
        <PaginationComponent
          pageSize={onboardPageSize}
          tablePageIndex={onboardPageIndex}
          totalRecords={onboardTotalRecords}
          pageCount={onboardTotalPages}
          handleSetPageSize={handleOnboardSetPageSize}
          handlePreviousPage={handleOnboardPreviousPage}
          handleNextPage={handleOnboardNextPage}
          handleGotoPage={handleOnboardGotoPage}
          canPreviousPage={canPreviousPageOnboard}
          canNextPage={canNextPageOnboard}
        />
      </div>

      {/* order */}
      <div>
        <h4 style={{ marginTop: 40 }}>Orders</h4>

        <table
          border="1"
          className="dashboardTable"
          cellPadding="10"
          style={{ width: "100%", borderCollapse: "", textAlign: "center" }}
        >
          <thead style={{ textAlign: "center" }}>
            <tr>
              <th rowSpan="2">Sr. No</th>
              <th rowSpan="2">Name</th>
              <th colSpan="6" style={{ background: "#e46f50", color: "white" }}>
                Today
              </th>
              <th colSpan="6" style={{ background: "#e46f50", color: "white" }}>
                Monthly
              </th>
            </tr>
            <tr className="sub-header">
              <th colSpan="2">MQG</th>
              <th colSpan="2">AO</th>
              <th colSpan="2">MAP</th>
              <th colSpan="2">MQG</th>
              <th colSpan="2">AO</th>
              <th colSpan="2">MAP</th>
            </tr>
            <tr border="1" className="sub-sub-header">
              <th></th>
              <th></th>

              <th style={{ background: "#ffb380", color: "white" }}>count</th>
              <th style={{ background: "#ffb380" }}>Amount</th>
              <th style={{ background: "#ffb380", color: "white" }}>count</th>
              <th style={{ background: "#ffb380", color: "white" }}>Amount</th>
              <th style={{ background: "#ffb380", color: "white" }}>count</th>
              <th style={{ background: "#ffb380", color: "white" }}>Amount</th>
              <th style={{ background: "#ffb380", color: "white" }}>count</th>
              <th style={{ background: "#ffb380", color: "white" }}>Amount</th>
              <th style={{ background: "#ffb380", color: "white" }}>count</th>
              <th style={{ background: "#ffb380", color: "white" }}>Amount</th>
              <th style={{ background: "#ffb380", color: "white" }}>count</th>
              <th style={{ background: "#ffb380", color: "white" }}>Amount</th>
            </tr>
          </thead>
          <tbody border="1">
            {salesUserData &&
              salesUserData.map((row, index) => (
                <tr key={index} border="1">
                  <td>
                    <strong>{pageIndex * pageSize + index + 1}</strong>
                  </td>
                  <td>{row.name}</td>
                  <td>{row.tmerchatntQoutationGeneratedCount}</td>
                  <td>{row.tmerchatntQoutationGeneratedAmount}</td>
                  <td>{row.tapprovedOrderCoutn}</td>
                  <td>{row.tapprovedOrderAmount}</td>
                  <td>{row.tmerchatApprovelPendingOrderCount}</td>
                  <td>{row.tmerchatApprovelPendingOrderAmount}</td>

                  <td>{row.mmerchatntQoutationGeneratedCount}</td>
                  <td>{row.mmerchatntQoutationGeneratedAmount}</td>
                  <td>{row.mapprovedOrderCoutn}</td>
                  <td>{row.mapprovedOrderAmount}</td>
                  <td>{row.mmerchatApprovelPendingOrderCount}</td>
                  <td>{row.mmerchatApprovelPendingOrderAmount}</td>
                </tr>
              ))}

              {/* Grand Total Row */}
              <tr style={{ backgroundColor: "#f4f4f4", fontWeight: "bold" }}>
                <td colSpan="2" style={{ textAlign: "center" }}><strong>Grand Total</strong></td>
                <td>{salesUserTotals.t.tmerchatntQoutationGeneratedCountTotal}</td>
                <td>{salesUserTotals.t.tmerchatntQoutationGeneratedAmountTotal}</td>
                <td>{salesUserTotals.t.tapprovedOrderCoutnTotal}</td>
                <td>{salesUserTotals.t.tapprovedOrderAmountTotal}</td>
                <td>{salesUserTotals.t.tmerchatApprovelPendingOrderCountTotal}</td>
                <td>{salesUserTotals.t.tmerchatApprovelPendingOrderAmountTotal}</td>

                <td>{salesUserTotals.m.mmerchatntQoutationGeneratedCountTotal}</td>
                <td>{salesUserTotals.m.mmerchatntQoutationGeneratedAmountTotal}</td>
                <td>{salesUserTotals.m.mapprovedOrderCoutnTotal}</td>
                <td>{salesUserTotals.m.mapprovedOrderAmountTotal}</td>
                <td>{salesUserTotals.m.mmerchatApprovelPendingOrderCountTotal}</td>
                <td>{salesUserTotals.m.mmerchatApprovelPendingOrderAmountTotal}</td>
              </tr>
          </tbody>
        </table>

        <PaginationComponent
          pageSize={pageSize}
          tablePageIndex={pageIndex}
          totalRecords={totalRecords}
          pageCount={totalPages}
          handleSetPageSize={handleSetPageSize}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handleGotoPage={handleGotoPage}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
        />
      </div>

      {/* Visits */}
      <div>
        <h4 style={{ marginTop: 40 }}>Visits</h4>

        <table
          border="1"
          className="dashboardTable"
          cellPadding="10"
          style={{
            width: "100%",
            borderCollapse: "collapse",
            textAlign: "center",
          }}
        >
          <thead style={{ textAlign: "center" }}>
            <tr>
              <th rowSpan="2">Sr. No</th>
              <th rowSpan="2">Name</th>
              <th colSpan="2">Today</th>
              <th colSpan="2">Monthly</th>
            </tr>
            <tr>
              <th colSpan="1" style={{ background: "#ffb380", color: "white" }}>
                Fresh
              </th>
              <th colSpan="1" style={{ background: "#ffb380", color: "white" }}>
                Revisit
              </th>
              <th colSpan="1" style={{ background: "#ffb380", color: "white" }}>
                Fresh
              </th>
              <th colSpan="1" style={{ background: "#ffb380", color: "white" }}>
                Revisit
              </th>
            </tr>
          </thead>
          <tbody border="1">
            {visitData &&
              visitData.map((row, index) => (
                <tr key={index} border="1">
                  <td>
                    <strong>
                      {visitPageIndex * visitPageSize + index + 1}
                    </strong>
                  </td>
                  <td>{row.name}</td>
                  <td>{row.tFreshVisitsMerchantCount}</td>
                  <td>{row.tRevisitMerchantCount}</td>

                  <td>{row.mFreshVisitsMerchantCount}</td>
                  <td>{row.mRevisitMerchantCount}</td>
                </tr>
              ))}

              {/* Grand Total Row */}
              <tr style={{ backgroundColor: "#f4f4f4", fontWeight: "bold" }}>
                <td colSpan="2" style={{ textAlign: "center" }}><strong>Grand Total</strong></td>
                <td><strong>{visitTotals.t.tFreshVisitsMerchantCountTotal}</strong></td>
                <td><strong>{visitTotals.t.tRevisitMerchantCountTotal}</strong></td>
                <td><strong>{visitTotals.m.mFreshVisitsMerchantCountTotal}</strong></td>
                <td><strong>{visitTotals.m.mRevisitMerchantCountTotal}</strong></td>
              </tr>
          </tbody>
        </table>

        <PaginationComponent
          pageSize={visitPageSize}
          tablePageIndex={visitPageIndex}
          totalRecords={visitTotalRecords}
          pageCount={visitTotalPages}
          handleSetPageSize={handleVisitSetPageSize}
          handlePreviousPage={handleVisitPreviousPage}
          handleNextPage={handleVisitNextPage}
          handleGotoPage={handleVisitGotoPage}
          canPreviousPage={canPreviousPageVisit}
          canNextPage={canNextPageVisit}
        />
      </div>
    </div>
  );
};

const PaginationComponent = ({
  handleGotoPage,
  tablePageIndex,
  handlePreviousPage,
  canPreviousPage,
  handleNextPage,
  canNextPage,
  pageCount,
  totalRecords,
  pageSize,
  handleSetPageSize,
}) => {
  return (
    <div className="row m-0">
      <div className="pagination col-lg-12">
        <div className="col-lg-2">
          <button
            className="defaultPaginationButton"
            onClick={() => handleGotoPage(0)}
            disabled={tablePageIndex === 0}
          >
            {"<<"}
          </button>{" "}
          <button
            className="defaultPaginationButton"
            onClick={handlePreviousPage}
            disabled={!canPreviousPage}
          >
            {"<"}
          </button>{" "}
          <button
            className="defaultPaginationButton"
            onClick={handleNextPage}
            disabled={!canNextPage}
          >
            {">"}
          </button>{" "}
          <button
            className="defaultPaginationButton"
            onClick={() => handleGotoPage(pageCount - 1)}
            disabled={!canNextPage}
          >
            {">>"}
          </button>{" "}
        </div>
        <div className="col-lg-2">
          <span>
            Total Records <strong>{totalRecords}</strong>{" "}
          </span>
        </div>
        <div className="col-lg-2">
          <span>
            Page{" "}
            <strong>
              {tablePageIndex + 1} of {pageCount}
            </strong>{" "}
          </span>
        </div>
        <div className="col-lg-3">
          <span>
            Go to page{" "}
            <input
              type="number"
              defaultValue={tablePageIndex + 1}
              onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                handleGotoPage(page);
              }}
              className="gotoPage"
            />
          </span>{" "}
        </div>
        <div className="col-lg-3">
          <select
            value={pageSize}
            onChange={(e) => {
              handleSetPageSize(Number(e.target.value));
            }}
            className="selectDisplayNoOfRecords"
          >
            {[10, 20, 30, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SalesDashboard;
